module.exports = __webpack_public_path__ + "img/selfExamination.ca70b685.png";